import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MaskLines, Reveal } from "@/components/Reveal";

export default function PageHero({ eyebrow, title, sub, children, tint = "#F8FAFC" }) {
  const lines = Array.isArray(title) ? title : [title];
  return (
    <section className="relative overflow-hidden border-b border-slate-200" style={{ backgroundColor: tint }}>
      <svg
        className="pointer-events-none absolute -right-24 top-1/2 h-[560px] w-[560px] -translate-y-1/2 text-gold/25"
        viewBox="0 0 100 100"
        fill="none"
        aria-hidden="true"
      >
        <path d="M50 2 98 50 50 98 2 50Z" stroke="currentColor" strokeWidth="0.5" />
        <path d="M50 14 86 50 50 86 14 50Z" stroke="currentColor" strokeWidth="0.4" />
      </svg>
      <div className="container-x relative z-10 pb-16 pt-36 sm:pb-20 sm:pt-44">
        <Reveal delay={0.05}>
          <p className="eyebrow flex items-center gap-3">
            <span className="inline-block h-px w-10 bg-amber-600/60" />
            {eyebrow}
          </p>
        </Reveal>
        <MaskLines
          lines={lines}
          className="mt-5 max-w-4xl font-display text-4xl font-extrabold leading-[1.06] tracking-tight text-navy sm:text-6xl"
        />
        {sub && (
          <Reveal delay={0.45}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">{sub}</p>
          </Reveal>
        )}
        {children && (
          <Reveal delay={0.6}>
            <div className="mt-9 flex flex-wrap items-center gap-4">{children}</div>
          </Reveal>
        )}
      </div>
    </section>
  );
}

export function ScrollCta({ href, label, primary = true, testId }) {
  const onClick = (e) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <a href={href} onClick={onClick} className={primary ? "btn-gold" : "btn-outline"} data-testid={testId}>
      {label} <ArrowRight className="h-4 w-4" />
    </a>
  );
}
